module.exports = __webpack_public_path__ + "static/img/proImg7.a99402a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/proImg7.png
// module id = xAmz
// module chunks = 1